<li>
  <div class="badge {{ level }}">
    <mat-icon>{{ icon }}</mat-icon>
  </div>
  <div class="panel mat-elevation-z2" [class.inverted]="inverted" [class.expandable]="expandable" [class.deeplink]="deeplink" (click)="handleClick()" ngClass.lt-md="single-sided">
    <div class="title">
      <h2>{{ title }}</h2>
      <mat-icon *ngIf="expandable">{{ expanded ? "expand_less" : "expand_more" }}</mat-icon>
    </div>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </div>
</li>
